import initialState from './initialState';

export default function occupationReducer(state = initialState.occupation, action) {
  switch (action.type) {
    case 'SET_OCCUPATION_OPTIONS':
      return Object.assign({}, state, {
        positions: action.positions,
        industries: action.industries
      })

    default:
      return state
  }
}
